// Device fingerprint pro app TV.
//
// Fase 4A.7-C: deixou de ser UUID v4 raso em localStorage e agora
// é wrapper de `packages/device/device-id.ts` (triple-write IDB+LS+
// Cache API, com prefixos `tizen-duid:` / `webos-lgudid:` / `web-uuid:`).
//
// `primaryId` agora pode chegar permanente no backend (DUID/LGUDID
// não mudam mesmo após reinstalar o app), o que prepara terreno
// pra anti-piracy/device limit/admin Fase 4B.

import { detectPlatform, getDeviceId } from '@app-iptv/device'
import type { Platform } from '@app-iptv/shared'

export interface DeviceInfo {
  primaryId: string
  hardwareHash?: string
  platform: Platform
  platformVersion?: string
  model?: string
}

/** Cache em memória — `getDeviceId()` é async + tem IO (IDB/Cache),
 *  evita refazer em cada login/refresh. */
let cached: DeviceInfo | null = null

// P2 (perf/tv-hero-coldstart): single-flight da PROMISE em voo, não só do valor.
// No boot frio, TrialGate (→ api.trialStatus) e o 1º signStream chamam
// `getDeviceInfo()` concorrentemente — cada um antes de `cached` estar setado —
// e ambos caíam em `getDeviceId()`, refazendo IDB+Cache+Luna em duplicata. Com o
// slot em voo, chamadas concorrentes compartilham UMA resolução.
let inflight: Promise<DeviceInfo> | null = null

export function getDeviceInfo(): Promise<DeviceInfo> {
  if (cached) return Promise.resolve(cached)
  if (inflight) return inflight
  // IIFE async + try/finally (construção de linguagem, ES5-safe): `.finally` de
  // Promise é Chr63+, abaixo do piso da TV (Chr38/53). Limpa o slot ao terminar
  // (sucesso OU falha) — no sucesso `cached` já responde direto; numa falha
  // transitória a próxima chamada re-tenta em vez de herdar promise rejeitada.
  inflight = (async (): Promise<DeviceInfo> => {
    try {
      const info = await getDeviceId()
      cached = {
        primaryId: info.id, // já vem prefixado (tizen-duid:.../webos-lgudid:.../web-uuid:...)
        platform: detectPlatform() as DeviceInfo['platform'],
      }
      return cached
    } finally {
      inflight = null
    }
  })()
  return inflight
}
